import { CartService } from './services';
import {
  CartDrawer,
  InitProductForms,
  QuantityComponents,
  CartCount,
  InitAddToCartButtons,
  InitCarts,
  Customers,
  InitCartAwareProductForms,
  InitFreeShippingNotices,
  CartAlert,
} from './components';

const MXShop = function (options) {
  const defaultOptions = {
    openOnAdd: true,
    hasCustomers: true,
    cartAware: false,
    freeShipping: false,
    hasCartDrawer: true,
    cartAlert: false,
  };
  options = { ...defaultOptions, ...options };
  Shopify.cartService = CartService();
  Shopify.cartService.init();
  InitProductForms();
  InitAddToCartButtons();
  QuantityComponents();
  InitCarts();
  CartCount('[sh-cart-count]');
  if (options.hasCartDrawer) {
    CartDrawer({ openOnAdd: options.openOnAdd });
  }
  if (options.hasCustomers) {
    Customers();
  }
  if (options.cartAware) {
    InitCartAwareProductForms(options.hasCartDrawer);
  }
  if (options.freeShipping) {
    InitFreeShippingNotices();
  }
  if (options.cartAlert) {
    CartAlert();
  }
};

export default MXShop;
